<template>
  <div class="radio-button-group">
    <div
      v-for="option in options"
      :key="option.value"
      class="radio-button-item"
    >
      <input
        :id="`${name}-${option.value}`"
        type="radio"
        :name="name"
        :value="option.value"
        :checked="modelValue === option.value"
        @change="handleChange(option.value)"
        class="radio-input"
      />
      <label
        :for="`${name}-${option.value}`"
        class="radio-label"
      >
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script setup>
import { colors } from '../../../consts/colors';

const props = defineProps({
  modelValue: {
    type: String,
    required: true
  },
  options: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every(option =>
        typeof option === 'object' &&
        'value' in option &&
        'label' in option
      );
    }
  },
  name: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);

const handleChange = (value) => {
  emit('update:modelValue', value);
};
</script>

<style lang="scss" scoped>
.radio-button-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.radio-button-item {
  display: flex;
  align-items: center;
}

.radio-input {
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: pointer;
  accent-color: v-bind('colors.blue[500]');

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: 2px solid v-bind('colors.blue[500]');
    outline-offset: 2px;
  }
}

.radio-label {
  margin-left: 8px;
  margin-bottom: 0;
  font-size: 14px;
  color: v-bind('colors.textPrimary');
  cursor: pointer;
  user-select: none;

  &:hover {
    color: v-bind('colors.blue[500]');
  }
}
</style>
